export const Heading = {
  variants: {
    pageHeader: {
      fontSize: '2.5rem',
      lineHeight: '3rem',
    },
    h1: {
      fontSize: '6xl',
      fontWeight: '700',
    },
    h6: {
      fontSize: 'xl',
      fontWeight: '500',
      lineHeight: '3xl',
    },
  },
}
